module.exports = __webpack_public_path__ + "static/media/court.4b263ec9.jpg";